<!-- message.component.html -->
<div class="message mt-16" *ngIf="type === 'loading'">
  <div class="icon">
    <div class="spinner-custom"></div>
  </div>

  <div class="text font-regular text-green">
    <span class="font-bold-dali ">{{ messageLoading }}</span>&nbsp;{{
    boldMessageLoading }}
  </div>
</div>
<div class="message mt-16" *ngIf="type === 'update'">
  <div class="icon">{{ alertIcon }}</div>
  <div class="text font-regular">
    <span class="font-semiBold text-green">{{ boldMessage }}</span>
  </div>
</div>
<div class="message-alert mt-16" *ngIf="type === 'alert'">
  <div class="icon">{{ alertIcon }}</div>
  <div class="text">
    <span [innerHTML]="message"></span>&nbsp;
    <span class="font-semiBold">{{ boldMessage }}</span>
    <div class="text" *ngIf="extraMessage">
      **Recuerda que te mostramos el
      <span class="font-semiBold"> stock disponible en este momento.</span>
    </div>
  </div>
</div>
<div class="message-alert-tons mt-16" *ngIf="type === 'tons'">
 <div class="d-flex align-items-center vw-100 justify-content-between">
  <div class="d-flex align-items-center">
    <span class="font-semiBold fts-16 line-height-24 mr-10">{{ message }}</span>
    <mat-icon
    svgIcon="icon_alert_black"
    class="show-desktop-tablet"
    [ngStyle]="{ width: '1rem', cursor: 'pointer' }"
    [matTooltip]="tooltipText"
    matTooltipClass="custom-tooltip-tons"
    matTooltipPosition="above"
    (mouseover)="tooltipDesktop?.show()"
    #tooltipDesktop="matTooltip"
  ></mat-icon>
  <mat-icon
    svgIcon="icon_alert_black"
    class="show-mobile"
    [ngStyle]="{ width: '1rem', cursor: 'pointer' }"
    [matTooltip]="tooltipText"
    matTooltipClass="custom-tooltip-tons"
    matTooltipPosition="above"
    (click)="tooltipMobile?.toggle()"
    #tooltipMobile="matTooltip"
  ></mat-icon>
  </div>
  <div class="text d-flex align-items-center">
    <span class="font-regular weight-volume fts-14 d-flex align-items-center show-desktop-tablet">
      <img src="assets/svg/icon-weight.svg" alt="icon-weight" class="mr-8">
      Peso:
      <span class="font-bold ml-4 mt-4 d-block-value">{{ weight }}</span>
    </span>
    
    <span class="font-regular weight-volume fts-14 d-flex align-items-center show-desktop-tablet">
      <img src="assets/svg/icon-volume.svg" alt="icon-volume" class="mr-8">
      Volumen:
      <span class="font-bold ml-4 mt-4 d-block-value line-height-14">{{ volume }}</span>
    </span>
     <div
    class="d-flex align-items-center img-user ml-16"
    [ngClass]="{
      disabled: loadingStockReal || (weight == '-' && volume == '-')
    }"
  >
    <span
      class="text-show font-semiBold fts-14"
      [ngClass]="
        loadingStockReal || (weight == '-' && volume == '-')
          ? 'color-disabled'
          : 'color-secondary'
      "
      (click)="emitDetail()"
      [attr.aria-disabled]="loadingStockReal || (weight == '-' && volume == '-')"
    >
      Ver detalle 
    </span>
  
    <img
      [src]="'assets/image/home-seller/' + (loadingStockReal || (weight == '-' && volume == '-') ? 'caretRight_disabled' : 'caretRight_regular') + '.svg'"
      width="16px"
      alt="Icono de detalle"
    />
  </div>
  
  </div>
 </div>
 <div class="show-mobile mt-10">
  <div class="text d-flex align-items-center">
    <span class="font-regular weight-volume fts-14 d-flex align-items-center"><img src="assets/svg/icon-weight.svg" alt="icon-weight" class="mr-8"> Peso: <span class="font-bold ml-4 mt-4 mr-16 word-wrap-text">{{weight}}</span></span>
    <span class="font-regular pv-0 ph-16 fts-14  d-flex align-items-center"><img src="assets/svg/icon-volume.svg" alt="icon-volume" class="mr-8">Volumen: <span class="font-bold ml-4 mt-4 word-wrap-text line-height-14">{{volume}}</span></span>
 </div>
 </div>
</div>
<div class="message-alert mt-16" *ngIf="type === 'alertTons'">
  <div class="icon" *ngIf="alertIcon">{{ alertIcon }}</div>
  <div class="icon d-flex align-items-center" *ngIf="alertImg"><img src="{{ alertImg }}" alt=""></div>
  <div class="text ta-s">
    <span [innerHTML]="message"></span>
  </div>
  <div class="d-flex align-items-center img-user ml-16 content-button justify-content-end" *ngIf="buttonText">
    <span class="text-show font-semiBold fts-14 color-secondary"  (click)="emitDetail()">
      {{buttonText}}
    </span>
    <img
    src="assets/image/home-seller/caretRight_regular.svg"
    width="16px"
    alt="Icono de detalle"
  />
  </div>
</div>